var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgObservability(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M14 8C14 11.3137 11.3137 14 8 14C4.68629 14 2 11.3137 2 8C2 4.68629 4.68629 2 8 2C11.3137 2 14 4.68629 14 8Z",
    fill: "#6C7689"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00002 2.625C5.03148 2.625 2.62502 5.03147 2.62502 8C2.62502 10.9685 5.03148 13.375 8.00002 13.375C10.9685 13.375 13.375 10.9685 13.375 8C13.375 5.03147 10.9685 2.625 8.00002 2.625ZM1.37502 8C1.37502 4.34111 4.34113 1.375 8.00002 1.375C11.6589 1.375 14.625 4.34111 14.625 8C14.625 9.60438 14.0547 11.0756 13.1058 12.2219L14.442 13.5581C14.686 13.8021 14.686 14.1979 14.442 14.4419C14.1979 14.686 13.8022 14.686 13.5581 14.4419L12.2219 13.1058C11.0756 14.0547 9.6044 14.625 8.00002 14.625C4.34113 14.625 1.37502 11.6589 1.37502 8ZM5.50002 7.375C5.84519 7.375 6.12502 7.65482 6.12502 8V10C6.12502 10.3452 5.84519 10.625 5.50002 10.625C5.15484 10.625 4.87502 10.3452 4.87502 10V8C4.87502 7.65482 5.15484 7.375 5.50002 7.375ZM8.62502 6C8.62502 5.65482 8.34519 5.375 8.00002 5.375C7.65484 5.375 7.37502 5.65482 7.37502 6V10C7.37502 10.3452 7.65484 10.625 8.00002 10.625C8.34519 10.625 8.62502 10.3452 8.62502 10V6ZM10.5 6.375C10.8452 6.375 11.125 6.65482 11.125 7V10C11.125 10.3452 10.8452 10.625 10.5 10.625C10.1548 10.625 9.87502 10.3452 9.87502 10V7C9.87502 6.65482 10.1548 6.375 10.5 6.375Z",
    fill: "#6C7689"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgObservability);
export default __webpack_public_path__ + "static/media/observability.d5b5560d46d93413988925f0f027885d.svg";
export { ForwardRef as ReactComponent };